import Version from "./Info";
import { Box, Typography, useMediaQuery, useTheme, Stack } from "@mui/material";
import { arcadeGradient } from "../theme";

function Footer() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box
			component="footer"
			sx={{
				width: '100%',
				minHeight: { xs: 'auto', sm: 48 },
				py: { xs: 1.5, sm: 1 },
				px: 2,
				background: arcadeGradient(theme),
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				mt: 'auto',
				borderTop: '1px solid rgba(255,255,255,0.16)',
				transition: 'background 0.3s ease',
				boxShadow: '0 -8px 24px rgba(15, 23, 42, 0.12)'
			}}
		>
			{isMobile ? (
				<Stack spacing={0.25} alignItems="center">
					<Typography
						variant="caption"
						sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}
					>
						QuizBoss v{Version.Version.version}
					</Typography>
					<Typography
						variant="caption"
						sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.65rem' }}
					>
						by {Version.Version.author}
					</Typography>
				</Stack>
			) : (
				<Typography
					variant="body2"
					sx={{
						color: 'rgba(255,255,255,0.9)',
						fontWeight: 500,
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						flexWrap: 'wrap',
						justifyContent: 'center'
					}}
				>
					<span style={{ fontWeight: 700 }}>QuizBoss</span>
					<Box
						component="span"
						sx={{
							width: 4,
							height: 4,
							borderRadius: '50%',
							bgcolor: 'rgba(255,255,255,0.4)',
							display: { xs: 'none', md: 'inline-block' }
						}}
					/>
					<span>Built by {Version.Version.author}</span>
					<Box
						component="span"
						sx={{
							width: 4,
							height: 4,
							borderRadius: '50%',
							bgcolor: 'rgba(255,255,255,0.4)'
						}}
					/>
					<span>v{Version.Version.version}</span>
					<Box
						component="span"
						sx={{
							width: 4,
							height: 4,
							borderRadius: '50%',
							bgcolor: 'rgba(255,255,255,0.4)',
							display: { xs: 'none', lg: 'inline-block' }
						}}
					/>
					<Box component="span" sx={{ display: { xs: 'none', lg: 'inline' } }}>
						Updated: {Version.Version.date}
					</Box>
				</Typography>
			)}
		</Box>
	);
}

export default Footer;
